const actionTypes = {
  ADD_QUERY: "ADD_QUERY",
  ADD_LOCATIONS_LIST: "ADD_LOCATIONS_LIST_TO_QUERY",
  BUMP_QUERY: "BUMP_QUERY",
  DELETE_QUERY: "DELETE_QUERY"
};

export default actionTypes;
